import React from "react";
import { House, Building2, Factory, Check } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const systems = [{
  title: "Residential Protection",
  icon: House,
  description: "Preserve the beauty and integrity of your home's exterior surfaces against weathering, moisture, and daily wear.",
  benefits: ["Driveways & Patios", "Pool Decks & Walkways", "Enhanced Stain Resistance", "Long-lasting Curb Appeal"]
}, {
  title: "Commercial Solutions",
  icon: Building2,
  description: "Heavy-duty sealing designed for high-traffic areas, ensuring safety, durability, and a professional appearance.",
  benefits: ["Retail Entryways", "Office Complex Walkways", "Improved Slip Resistance", "Reduced Maintenance Costs"]
}, {
  title: "Industrial Grade",
  icon: Factory,
  description: "Maximum strength protection for demanding environments exposed to harsh chemicals, heavy machinery, and extreme conditions.",
  benefits: ["Warehouse Flooring", "Loading Docks", "Chemical & Oil Resistance", "Structural Reinforcement"]
}];
export default function AdvancedProtectionSystems() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="advanced-protection-systems" ref={ref} className="py-24 bg-background relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground">
            Advanced Protection Systems
          </h2>
          <p className="text-lg text-muted-foreground">
            Tailored sealing and waterproofing solutions for every scale of application.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {systems.map((system, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-${i * 150} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <Card className="group relative h-full border-border/50 bg-card overflow-hidden hover:shadow-lg transition-shadow duration-300">
                {}
                <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-[color:var(--ring)]/10 to-transparent opacity-50 group-hover:opacity-80 transition-opacity duration-500 pointer-events-none" />
                
                <CardHeader className="pb-2">
                  <div className="mb-6 flex justify-center">
                    <div className="p-4 rounded-full bg-accent/50 group-hover:bg-[color:var(--ring)]/10 transition-colors duration-300">
                      <system.icon className="w-12 h-12 text-foreground group-hover:text-[color:var(--ring)] transition-all duration-300 group-hover:scale-110 group-hover:stroke-[1.5px]" strokeWidth={1} />
                    </div>
                  </div>
                  <CardTitle className="text-xl text-center mb-2">{system.title}</CardTitle>
                  <CardDescription className="text-center text-base">
                    {system.description}
                  </CardDescription>
                </CardHeader>
                
                <CardContent className="relative z-10 pt-4">
                  <ul className="space-y-3">
                    {system.benefits.map((benefit, j) => <li key={j} className="flex items-start gap-3 text-sm text-muted-foreground">
                        <Check className="w-5 h-5 text-[color:var(--ring)] shrink-0 mt-0.5" />
                        <span>{benefit}</span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}